const buildPersonnelRecordQuery = (personnelId) => ({
  form_head_uuid: "9beb839e9fd511eeb2180242321230b4",
  pmsstuyxalhk2sma: [String(personnelId)],
  needpage: false,
  page: 1,
  limit: 1000,
});

const getHospitalId = (personnelRecords) => {
  const personnel = Array.isArray(personnelRecords)
    ? personnelRecords[0]
    : null;
  const hospital = personnel
    && personnel.ncsykhjeov4w9fei
    && personnel.ncsykhjeov4w9fei[0]
    && personnel.ncsykhjeov4w9fei[0][0];
  return hospital ? hospital.id : null;
};

const buildHospitalNoticeQuery = (hospitalId) => ({
  form_head_uuid: "bf7a80f39ecf4ae1b19bffb4f299e925",
  qpefzsrslvjmcyjz: [`[${hospitalId}]`],
  needpage: false,
  page: 1,
  limit: 1,
  keyword: "",
  select_option: "",
});

module.exports = {
  buildPersonnelRecordQuery,
  getHospitalId,
  buildHospitalNoticeQuery,
};



// WEBPACK FOOTER //
// ./src/util/personnelRecordQuery.js